import { fg } from '@atlaskit/platform-feature-flags';

import {
	DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
} from '../../entities';
import {
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { GithubIcon } from './icon';
import { GithubSearchResultIcon } from './search-result-icon';


const getGithubTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	config.set(TypeFilterValueKey.Repository, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.PullRequest, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Branch, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Commit, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI,
		subTypes3P: [],
	});

	if (fg('rovo_fps_enable_github_work_item_type_filter')) {
		config.set(TypeFilterValueKey.DevopsWorkItem, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	return config;
};

export const githubConfig: ThirdPartyConfig = {
	displayName: 'GitHub',
	id: 'github',
	resourceType: 'github-connector',
	icon: get3PLogo(GithubIcon, 'Github', 'medium'),
	searchResultIcon: get3PLogo(GithubSearchResultIcon, 'Github', 'large'),
	integrationAri: 'ari:cloud:platform::integration/github',
	get typeFilterConfig() {
		return getGithubTypeFilterConfig();
	},
	filters: ['lastUpdated', 'onlyTitleMatch', 'pullRequestStatus'],
	requiresOauth: true,
	isEnabled: () => true,
};
